<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <v-row justify="start" align="start" class="ma-0 mb-4 mt-5">
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #193D6E;">{{ texts.clients.title }}</div>
        </v-col>
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-regular'; font-size: 14px;">
            {{ texts.clients.subTitle }}
          </div>
        </v-col>
      </v-row>
      <v-row class="ma-0 mb-4" style="align-items: center;">
        <v-col cols="12" sm="4" md="2" lg="3" class="pl-0">
          <v-text-field v-model="search" min-width="288" max-width="288" label="Buscar" hide-details style="font-family: 'montserrat-medium'; border-radius: 20px; background-color: white;" append-icon="mdi-magnify" outlined></v-text-field>
        </v-col>
        <v-col class="d-flex justify-end pa-0 my-4">
          <v-btn
            color="#0075B8"
            elevation="8"
            class="mr-2"
            style="color: #0075BB; border-radius: 36px; border: 2px solid #0075BB; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            @click="openDialogSupplier"
          >
            <v-icon left>mdi-account</v-icon>
            {{ texts.suppliers.addClient }}
          </v-btn>
          <v-btn
            color="#0075B8"
            elevation="8"
            class="white--text"
            style="border-radius: 36px; border: 2px solid #0075BB; font-family: 'montserrat-semibold'; text-transform: none;"
            @click="dataXLSX()"
          >
            <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
            {{ texts.suppliers.download }}
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table class="d-none d-sm-block" hide-default-header :search="search" :headers="headersContacts" :items="items" >
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">{{ texts.suppliers.name }}</th>     
              <th class="header__title center">{{ texts.suppliers.email }}</th>            
              <th class="header__title right">{{ texts.suppliers.actions }}</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.sName }}</td>
              <td class="table__item">{{ item.sEmail }}</td>
              <td class="table__item">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="openDialogDeleteSupplier(item)" :disabled="loading" v-bind="attrs" v-on="on" icon color="red">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ texts.suppliers.deleteSupplier }}</span> 
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-data-table class="d-sm-none d-block" hide-default-header :items="items">
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr class="table__item" style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
              <td class="table__item__mobile">
                <div>{{ texts.suppliers.name }}</div>
                <div>{{ item.sName }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.suppliers.email }}</div>
                <div>{{ item.sEmail }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.suppliers.actions }}</div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="openDialogDeleteSupplier(item)" :disabled="loading" v-bind="attrs" v-on="on" icon color="red">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ texts.suppliers.deleteSupplier }}</span> 
                  </v-tooltip>
                </div>
              </td>
            </tr>
            <v-divider></v-divider>
          </tbody>
        </template>
      </v-data-table>
    </v-container>

    <v-dialog v-model="dialog" persistent max-width="fit-content">
      <v-card>
        <v-stepper v-model="step" alt-labels elevation="0">
          <v-stepper-header color="#193D6E" class="mt-5 mr-15 ml-15" elevation="0" style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;">
            <v-stepper-step :complete="step > 1" step="1" color="#193D6E"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 2" step="2" color="#193D6E"></v-stepper-step>
          </v-stepper-header>
          <div class="mb-6" style="text-align: center; font-family: 'montserrat-bold'; font-size: 20px;">{{ texts.suppliers.createClient }}</div>
          <v-stepper-items>
            <!-- Paso 1: Crear un proveedor -->
            <v-stepper-content step="1" elevation="0" class="pt-0" style="width: 600px;">
              <v-card-text v-if="!loading">
                <v-container>
                  <v-row>
                    <v-form ref="formNew" style="width: 100%;" lazy-validation v-on:submit.prevent>
                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                            :label="texts.suppliers.name + '*'"
                            required
                            outlined
                            style="border-radius: 10px;"
                            v-model="forms.new.sName"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            :label="texts.suppliers.email + '*'"
                            required
                            outlined
                            style="border-radius: 10px;"
                            v-model="forms.new.sEmail"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-row>
                </v-container>
                <small>*{{ texts.suppliers.requiredField }}</small> 
              </v-card-text>
              <div v-else style="display: flex; justify-content: center;">
                <v-progress-circular
                  indeterminate
                  color="amber"
                ></v-progress-circular>
              </div>
              <v-card-actions class="pb-4" style="justify-content: space-evenly;">
                <v-btn
                  color="#0075B8"
                  elevation="8"
                  class="mr-2 px-6"
                  style="color: #0075BB; border-radius: 36px; border: 2px solid #0075BB; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                  outlined
                  :disabled="loading"
                  @click="dialog = false"
                >
                  {{ texts.modalForm.cancel }}
                </v-btn>
                <v-btn
                  color="#0075B8"
                  elevation="8"
                  class="white--text px-6"
                  style="border-radius: 36px; border: 2px solid #0075BB; font-family: 'montserrat-semibold'; text-transform: none;"
                  @click="sendVerification()"
                >
                  {{ texts.modalForm.continue }}
                </v-btn>
              </v-card-actions>
            </v-stepper-content>

            <!-- Paso 2: Confirmación -->
            <v-stepper-content step="2" class="pt-0">
              <v-container class="mt-1">
                <v-card-text class="py-6 pb-0">
                  <div class="pt-4 px-4 mb-4" style="display: flex; justify-content: space-around; flex-direction: row; width: 600px">
                    <div>
                      <v-otp-input v-model="otp" length="6" type="number" color="#193D6E"></v-otp-input>
                      <p style="font-size: 14px; font-weight: 500;">{{ texts.twoFactor.enterCode }}</p>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions class="pb-4" style="justify-content: space-evenly;">
                <v-btn
                  color="#0075B8"
                  elevation="8"
                  class="mr-2 px-6"
                  style="color: #0075BB; border-radius: 36px; border: 2px solid #0075BB; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                  outlined
                  :disabled="loading"
                  @click="dialog = false"
                >
                  {{ texts.modalForm.cancel }}
                </v-btn>
                <v-btn
                  color="#0075B8"
                  elevation="8"
                  class="white--text px-6"
                  style="border-radius: 36px; border: 2px solid #0075BB; font-family: 'montserrat-semibold'; text-transform: none;"
                  @click="saveSupplier()"
                >
                  {{ texts.modalForm.createClient }}
                </v-btn>
              </v-card-actions>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" persistent max-width="fit-content">
      <v-card class="pt-5">
        <div style="display: flex; flex-direction: column; align-items: center;">
          <v-img :src="require('@/assets/icons/delete.svg')" style="width: 70px; height: 70px; margin-bottom: -40px;"></v-img>
          <v-card-title class="text-h5 my-4 mt-0 mx-10 pt-10 pb-6 px-8" style="border-radius: 10px; background-color: #E31D1C; color: white; font-family: 'montserrat-semibold' !important; text-align: center;">
            ¿Estás seguro de que deseas eliminar al cliente?
          </v-card-title>
          <v-card-text v-if="!loading" class="mt-4" style="text-align: center; font-family: 'montserrat-semibold'; font-size: 18px;">Una vez que eliminas al cliente no podrás crear facturas asignadas a él.</v-card-text>
          <div v-else style="display: flex; justify-content: center;">
            <v-progress-circular
              indeterminate
              color="amber"
            ></v-progress-circular>
          </div>
        </div>
        <v-card-actions class="pb-4 mt-8" style="justify-content: space-evenly;">
          <v-btn
            color="#0075B8"
            elevation="8"
            class="mr-2 px-6"
            style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            :disabled="loading"
            @click="cancel()"
          >
            {{ texts.modalForm.cancel }}
          </v-btn>
          <v-btn
            color="red"
            elevation="8"
            class="white--text px-6"
            style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
            :disabled="loading"
            @click="deleteSupplier()"
          >
            {{ texts.modalForm.delete }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

export default {
  name: "SuppliersView",
  data() {
    return {
      nameXLSX: "Clientes.xlsx",
      texts: "",
      search: "",
      dialog: false,
      isLoading: false,
      dialogEdit: false,
      otp: "",
      dialogDelete: false,
      loading: false,
      step: 1,
      items: [],
      rules: {
        required: (v) => !!v || "El campo es obligatorio",
        clabeLength: (v) => (v && v.length === 18) || "La cuenta clabe debe tener exactamente 18 caracteres"
      },
      forms: {
        new: {
          sName: "",
          sEmail: "",
          sBank_name: "",
          sAccount_number: "",
        },
        detail: {
          sPaymentRecipientId: "",
          sName: "",
          sEmail: "",
          sAccountNumber: "",
          sBankName: "",
          sTaxId: "",
        },
        delete: {
          sClientRecipientId: "",
        },
      },
      // headersContacts: [
      //   { text: "Nombre", value: "sName", align: "center" },
      //   { text: "Correo", value: "sEmail", align: "center" },
      //   { text: "Nombre de banco", value: "sBankName", align: "center" },
      //   { text: "Número de clabe", value: "sAccountNumber", align: "center" },
      //   { text: "RFC", value: "sTaxId", align: "center" },
      //   { text: "Acciones", value: "actions", align: "center", sortable: false },
      // ],
      headersContacts : [
        this.selectLanguage === 'en' ? { text: "Name", value: "sName", align: "center" } : { text: "Nombre", value: "sName", align: "center" },
        this.selectLanguage === 'en' ? { text: "Email", value: "sEmail", align: "center" } : { text: "Correo", value: "sEmail", align: "center" },
        { text: "Actions", value: "actions", align: "center", sortable: false },
      ]
    };
  },
  created() {
  },
  methods: {
    getSuppliers: function () {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/${this.selectLanguage}/client-recipient/`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      }).then((response) => {
        this.items = response.data.paymentRecipients
        this.isLoading = false;
      }).catch((error) => {
          // this.isLoading = false;
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    formatMoney: function (value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(formattedNumber);
    },
    openDialogSupplier() {
      this.dialog = true;
    },
    openDialogDeleteSupplier(item) {
      this.dialogDelete = true;
      this.forms.delete = {
        sClientRecipientId: item.sClientRecipientId,
      }
    },
    sendVerification() {
      //Rule: Validate if the form is correct
      if (this.$refs.formNew.validate()) {
        this.step = 2;
        try {
        DB.get(`${URI}/api/v1/${this.selectLanguage}/authenticator/`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }).then((response) => {
          if(!response.data.success) {
           this.mixError(response.data.message, response.status);
          }
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
      }
      catch(error){
          this.mixError(error.response.data.message, error.response.status);
        }
      }
    },
    async validateOtp() {
      try {
        const payload = {
          sCode: this.otp
        };

        const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/authenticator/verify`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        return response.data.success;
      } catch (error) {
        console.error('Error in validateOtp:', error);
        return false;
      }
    },
    async saveSupplier() {
      if (this.$refs.formNew.validate()) {
        this.loading = true;

        const isOtpValid = await this.validateOtp();
        if (!isOtpValid) {
          this.loading = false;
          this.mixError('Invalid OTP', 400);
          return;
        }

        let payload = {
            sName: this.forms.new.sName,
            sEmail: this.forms.new.sEmail,
            sBankName: this.forms.new.sBank_name,
            sAccountNumber: this.forms.new.sAccount_number,
            sEntityBusiness: "COMPANY",
            sTaxId: this.forms.new.sTaxId,
        };

        DB.post(
            `${URI}/api/v1/${this.selectLanguage}/client-recipient/`,
            payload,
            {
              headers: {
                Authorization: this.$store.state.sToken
                  ? `Bearer ${this.$store.state.sToken}`
                  : ""
              }
            }
          )
        .then((response) => {
          this.loading = false;
          this.getSuppliers();
          this.cancel();
        })
        .catch((error) => {
          this.loading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
      } else {
        this.error = true;
        this.codeError = "INVALID_INPUT";
      }
    },
    deleteSupplier() {
      this.loading = true;

      let payload = {
        sClientRecipientId: this.forms.delete.sClientRecipientId,
      };

      DB.put(
          `${URI}/api/v1/${this.selectLanguage}/client-recipient/delete`,
          payload,
          {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            }
          }
        )
      .then((response) => {
        this.loading = false;
        this.getSuppliers();
        this.cancel();
      })
      .catch((error) => {
        this.loading = false;
        this.mixError(error.response.data.message, error.response.status);
      });
    },
    cancel() {
      this.dialog = false;
      this.step = 1;
      this.otp = "";
      this.loading = false;
      this.dialogEdit = false;
      this.dialogDelete = false;
      this.forms.new = {
        sName: '',
        sEmail: '',
        sBankName: '',
        sAccountNumber: '',
        sEntityBusiness: '',
        sTaxId: ''
      };
      this.forms.detail = {
        sPaymentRecipientId: '',
        sName: '',
        sEmail: '',
        sBankName: '',
        sAccountNumber: '',
        sEntityBusiness: '',
        sTaxId: ''
      }
      this.forms.delete = {
        sPaymentRecipientId: ''
      }
      
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    dataXLSX() {
      try {
        let data = this.items.map((item) => {
          return {
            Nombre: item.sName ? item.sName : "N/A",
            Correo: item.sEmail ? item.sEmail : "N/A",
          };
        });
        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(blob, this.nameXLSX);
        this.success = true;
        this.msgSuccess = "Descargando documento";
      } catch (error) {
        this.error = true;
        this.codeError = "CSV_NO_DATA";
      }
    },
    updateHeaders() {
      this.headersContacts = [
        {text: this.texts.suppliers.name, value: "sName", align: "center"},
        {text: this.texts.suppliers.email, value: "sEmail", align: "center"},
        {text: this.texts.suppliers.actions, value: "actions", align: "center", sortable: false}
      ];
    }
  },
  beforeMount() {
    this.texts = FILE.takeRate[this.selectLanguage];
    this.getSuppliers();
    this.updateHeaders();
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.takeRate[this.selectLanguage];
      }
      this.updateHeaders();
    }
  }
};
</script>

<style scoped>
.bg-container {
  width: 100%;
  background: #fff;
  opacity: 1;
  height: 100%;
}
.full-height {
  height: 100vh;
  width: 100%;
  overflow-y: auto;
}
.active {
  background-color: #f0f0f0;
}
/* .active-section .v-list-item__icon {
  color: yellow !important;
  background-color: yellow !important;
}

.active-section .v-list-item__title {
  background-color: yellow !important;
} */

.active-item {
  background-color: #f5f7f9 !important;
}
.button-add {
  background: transparent linear-gradient(258deg, #ffc556 0%, #fffc81 100%) 0%
    0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0px;
  color: #283c4d;
  text-transform: initial;
}
.v-tabs-slider {
  background: #f0be43 !important;
  height: 3px;
  color: #f0be43 !important;
  border-radius: 100px;
}

.card-main {
  width: 40vh;
  height: 16vh;
  position: relative;
  background: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  overflow: hidden;
}

.card-content {
  position: absolute;
  top: 19px;
  left: 16px;
}

.circle-content {
  text-align: center;
  color: white;
  margin: auto;
}

.btn-custom {
  color: #f0be43;
}

.card-title {
  color: #302e2e;
  font-size: 16px;
  font-family: montserrat-bold;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 8px;
}

.card-info,
.balance-title {
  color: #777777;
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
}

.card-mxn {
  width: 200px;
  color: #f0be43;
  font-size: 24px;
  font-family: Mons;
  font-weight: 700;
  line-height: 36px;
  font-style: normal;
  word-wrap: break-word;
}

.container-width,
.header-container {
  max-width: 1280px;
  margin: auto;
}

.title-medium {
  font-family: "montserrat-semibold";
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.headline-medium {
  font-family: "montserrat-semibold";
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  text-align: left;
}

.body-large {
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}

.blocked-amount {
  font-family: "montserrat-regular";
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.blocked-amount-2 {
  color: #302e2e;
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
}

.circle-sheet {
  width: 200px;
  height: 200px;
  padding-left: 17px;
  padding-right: 62px;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  position: absolute;
  right: -60px;
  top: -20px;
}

.usd-balance {
  color: #666565;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.content-balance {
  color: #302e2e;
  font-family: "montserrat-medium", sans-serif;
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
  text-align: left;
  padding-top: 10px;
}

.h5 {
  font-family: "montserrat-bold";
  font-size: 24px;
  line-height: 36px;
  text-align: left;
}

.buttonAddFounds {
  text-align: center;
  color: #f0be43;
  font-size: 16px;
  font-family: "montserrat-semibold";
  font-weight: 600;
  line-height: 24px;
  text-transform: capitalize;
  word-wrap: break-word;
}

.modalTextAddFounds {
  color: #302e2e;
  font-family: "Montserrat-Regular", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.table th {
  background-color: #f2f2f4;
  /* border: 1px solid #ccc; */
}

@media (max-width: 1150px) {
  .card-title {
    font-size: 14px;
  }

  .card-mxn {
    font-size: 20px;
  }

  .usd-balance {
    font-size: 12px;
  }

  .content-balance {
    font-size: 18px;
  }

  .blocked-amount {
    font-size: 12px;
  }

  .blocked-amount-2 {
    font-size: 14px;
  }

  .buttonAddFounds {
    font-size: 14px;
  }

  .circle-sheet {
    display: none;
  }
}

@media (max-width: 1250px) {
  .circle-sheet {
    width: 155px;
    height: 170px;
    padding-left: 17px;
    padding-right: 40px;
    right: -50px;
    top: -5px;
  }
}

</style>
